<ng-container *ngIf="event$ | async as event; else loader">
    <section class="background-color-nearwhite">
        <div class="container">
            <a class="back" da-link (click)="goBack(event.courseId)"
                ><span class="drg-icon-arrow_left"></span><span class="text" [innerHTML]="'event.backToCourse' | translate"></span
            ></a>
        </div>
        <div class="container event" *ngIf="event">
            <div class="inner-content">
                <h2 [innerHTML]="'event.title' | translate"></h2>
                <div>
                    <strong class="first" [innerHTML]="'event.subTitle' | translate"></strong>
                    <strong class="second">{{ courseTitle }}</strong>
                </div>
                <div>
                    <strong class="first" [innerHTML]="'event.date' | translate"></strong>
                    <span class="second"
                        >{{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }} - {{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}</span
                    >
                </div>
                <div>
                    <strong class="first" [innerHTML]="'event.duration' | translate"></strong>
                    <span *ngIf="!durationDays && durationTime <= 1"
                        ><span>{{ durationTime }} </span> <span [innerHTML]="'event.hour' | translate"></span
                    ></span>
                    <span *ngIf="!durationDays && durationTime > 1"
                        ><span>{{ durationTime }} </span> <span [innerHTML]="'event.hours' | translate"></span
                    ></span>
                    <span *ngIf="durationDays > 1"
                        ><span>{{ durationDays }} </span> <span [innerHTML]="'event.days' | translate"></span
                    ></span>
                    <span *ngIf="durationDays === 1"
                        ><span>{{ durationDays }} </span> <span [innerHTML]="'event.day' | translate"></span
                    ></span>
                </div>
                <div>
                    <strong class="first" [innerHTML]="'event.language' | translate"></strong>
                    <span class="second">{{ event.language }}</span>
                </div>
                <div>
                    <strong class="first" [innerHTML]="'event.address' | translate"></strong>
                    <span class="second">{{ event.location.street }}, {{ event.location.city }} {{ event.location.zip }}</span>
                </div>
                <div>
                    <strong class="first" [innerHTML]="'common.directions' | translate"></strong>
                    <a
                        *ngIf="event.location.isMapAvailable"
                        target="_blank"
                        [href]="envApi + 'api/v1/course/getlocationmap/' + event.location.locationSign"
                        class="second"
                        ><span [innerHTML]="'common.downloadRoute' | translate"></span
                    ></a>
                    <span class="line-wrapper"><span *ngIf="!event.location.isMapAvailable" class="line">line</span></span>
                </div>
                <div class="last">
                    <span [innerHTML]="'event.pleaseCntactUs' | translate"> </span>
                </div>
                <div class="button-wrapper">
                    <a
                        class="button primary"
                        *ngIf="event.freeSeats >= 1"
                        (click)="addToCart(event.externalId)"
                        [innerHTML]="'event.bookNow' | translate"
                    ></a>
                </div>
            </div>
            <div class="empty"></div>
            <ng-container *ngIf="showTrainers$ | async">
                <div class="trainers" *ngIf="trainers$ | async as trainers">
                    <h3 [innerHTML]="'event.titleTreiners' | translate" *ngIf="trainers && trainers.length > 0"></h3>
                    <ng-container *ngIf="trainers && trainers.length > 0">
                        <div class="trainer-wrapper" *ngIf="event.trainers[0]">
                            <div
                                *ngIf="event.trainers[0].image"
                                class="event.trainers[0] media">
                                <figure *ngIf="event.trainers[0].image.uri">
                                    <da-progressive-image
                                        [options]="{
                                            alt: event.trainers[0].firstName,
                                            aspectRatios: [
                                                {
                                                    breakpoint: 480,
                                                    width: 480,
                                                    height: 360,
                                                    akamaiImage: envApi + event.trainers[0].image.uri
                                                },
                                                {
                                                    breakpoint: 768,
                                                    width: 300,
                                                    height: 225,
                                                    akamaiImage: envApi + event.trainers[0].image.uri
                                                },
                                                {
                                                    breakpoint: 960,
                                                    width: 380,
                                                    height: 285,
                                                    akamaiImage: envApi + event.trainers[0].image.uri
                                                }
                                            ]
                                        }"
                                    ></da-progressive-image>
                                </figure>
                            </div>
                            <div class="content">
                                <strong
                                    >{{ event.trainers[0].title }} {{ event.trainers[0].firstName }}
                                    {{ event.trainers[0].lastName }}</strong
                                >
                                <!-- <p class="bio">
                                    Trainer short bio is shown here if there is one bio in TCM. The maximum length of the copy can be 200
                                    characters. If the bio is longer. Trainer short bio is shown here if there is one bio in TCM. End.
                                </p> -->
                            </div>
                        </div>
                        <div class="trainer-wrapper" *ngIf="event.trainers[1]">
                            <div
                                *ngIf="event.trainers[1].image"
                                class="event.trainers[1] media">
                                <figure *ngIf="event.trainers[1].image.uri">
                                    <da-progressive-image
                                        [options]="{
                                            alt: event.trainers[1].firstName,
                                            aspectRatios: [
                                                {
                                                    breakpoint: 480,
                                                    width: 480,
                                                    height: 360,
                                                    akamaiImage: envApi + event.trainers[1].image.uri
                                                },
                                                {
                                                    breakpoint: 768,
                                                    width: 300,
                                                    height: 225,
                                                    akamaiImage: envApi + event.trainers[1].image.uri
                                                },
                                                {
                                                    breakpoint: 960,
                                                    width: 380,
                                                    height: 285,
                                                    akamaiImage: envApi + event.trainers[0].image.uri
                                                }
                                            ]
                                        }"
                                    ></da-progressive-image>
                                </figure>
                            </div>
                            <div class="content">
                                <strong
                                    >{{ event.trainers[1].title }} {{ event.trainers[1].firstName }}
                                    {{ event.trainers[1].lastName }}</strong
                                >
                                <!-- <p class="bio">
                                    Trainer short bio is shown here if there is one bio in TCM. The maximum length of the copy can be 200
                                    characters. If the bio is longer. Trainer short bio is shown here if there is one bio in TCM. End.
                                </p> -->
                            </div>
                        </div>
                        <div class="trainer-wrapper list" *ngIf="event.trainers.length > 2">
                            <div class="content">
                                <strong [innerHTML]="'event.restOfTrainers' | translate"></strong>
                                <span *ngFor="let trainer of event.trainers; let i = index">
                                    <span *ngIf="i > 1">{{ trainer.title }} {{ trainer.firstName }} {{ trainer.lastName }}</span>
                                    <span *ngIf="i > 1 && i < trainers.length - 2">,</span>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </section>
    <ng-container *ngIf="showTrainers$ | async">
        <section
            *ngIf="event.organizationTrainer"
            [ngClass]="event.organizationTrainer ? 'background-color-white' : 'background-color-nearwhite'"
        >
            <div class="container organization-title"><h3 [innerHTML]="'event.titleOrganization' | translate"></h3></div>
            <div class="container organization">
                <div
                    class="media"
                    *ngIf="event.organizationTrainer.image">
                    <figure *ngIf="event.organizationTrainer.image.uri">
                        <da-progressive-image
                            [options]="{
                                alt: event.organizationTrainer.firstName,
                                aspectRatios: [
                                    {
                                        breakpoint: 480,
                                        width: 480,
                                        height: 360,
                                        akamaiImage: envApi + event.organizationTrainer.image.uri
                                    },
                                    {
                                        breakpoint: 768,
                                        width: 300,
                                        height: 225,
                                        akamaiImage: envApi + event.organizationTrainer.image.uri
                                    },
                                    {
                                        breakpoint: 960,
                                        width: 380,
                                        height: 285,
                                        akamaiImage: envApi + event.organizationTrainer.image.uri
                                    }
                                ]
                            }"
                        ></da-progressive-image>
                    </figure>
                </div>
                <div>
                    <h3>
                        {{ event.organizationTrainer.title }} {{ event.organizationTrainer.firstName }}
                        {{ event.organizationTrainer.lastName }}
                    </h3>
                    <div>
                        <span [innerHTML]="'event.organizationEmail' | translate"></span>
                        <a href="mailto: {{ event.organizationTrainer.email }}"
                            ><span [innerHTML]="event.organizationTrainer.email.toLowerCase()">{{
                                event.organizationTrainer.email
                            }}</span></a
                        >
                    </div>
                    <div *ngIf="event.organizationTrainer.phoneNumber">
                        <span [innerHTML]="'event.organizationHotline' | translate"></span>
                        <a href="tel: {{ event.organizationTrainer.phoneCity + event.organizationTrainer.phoneNumber }}"
                            ><span>
                                <!-- +<span [innerHTML]="event.organizationTrainer.phoneCountry.replaceAll('00', '').replaceAll('+', '')"></span> -->
                                <span [innerHTML]="event.organizationTrainer.phoneCity"></span
                                >{{ event.organizationTrainer.phoneNumber }}</span
                            ></a
                        >
                    </div>
                </div>
            </div>
        </section>
    </ng-container>

    <section [ngClass]="event.organizationTrainer && (showTrainers$ | async) ? 'background-color-nearwhite' : 'background-color-white'">
        <div class="container content"><da-hotels *ngIf="event && event.location" [hotels]="event.location.hotels"></da-hotels></div>
    </section>

    <div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
        <div class="modal">
            <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
                <div class="title">
                    <span class="checked"></span>
                    <span [innerHTML]="'courses.update' | translate"></span>
                </div>
                <div class="inner-wrapper">
                    <div class="details">
                        <span>{{ courseTitle }}</span>
                        <span>
                            {{ formattedPrice$ | async }}
                            <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span>
                        </span>
                    </div>
                    <div class="type">{{ event.courseType }}</div>
                    <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #warning>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warn"></ng-container>
    </div>
</ng-template>
<ng-template #warn>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInCartTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInCartText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notTheSameCurrencyPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="notTheSameCurrencyModal"></ng-container>
    </div>
</ng-template>
<ng-template #notTheSameCurrencyModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.currencyWarningTitle' | translate"></h3>
                <p [innerHTML]="'booking.currencyWarningText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCart()"
                            [innerHTML]="'courses.showCart' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>
